import React from 'react';
import { Skeleton } from '../../layout/loading';

export default function StackedListSkeleton({ count = 5 }) {
  return (
    <ul role="list" className="divide-y divide-gray-800">
      {Array.from({ length: count }).map((_, index) => (
        <li key={index} className="flex justify-between gap-x-6 py-5 px-4">
          <div className="flex min-w-0 gap-x-4 w-full">
            <div className="min-w-0 flex-auto">
              <div className="flex items-center gap-x-3">
                <Skeleton className="h-5 w-16 rounded-md" />
                <Skeleton className="h-6 w-48 rounded-md" />
              </div>
              <div className="mt-2 flex items-center gap-x-2">
                <Skeleton className="h-4 w-32 rounded-md" />
                <Skeleton className="h-4 w-24 rounded-md" />
              </div>
            </div>
          </div>
          <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end justify-center">
            <div className="flex items-center gap-x-4">
              <Skeleton className="h-9 w-28 rounded-md" />
              <Skeleton className="h-9 w-9 rounded-md" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
